import { RouteShell } from "@/components/route-shell";
import { SettingsLayout } from "@/components/settings-layout";
import { CustomerMappingTab } from "@/components/settings/customer-mapping-tab";
import { authClient } from "@/lib/auth-client";
import { trpc } from "@/lib/trpc";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { CloudOff } from "lucide-react";

export const Route = createFileRoute("/_app/settings/customer-mapping")({
	beforeLoad: async () => {
		const { data: session } = await authClient.getSession();
		if (session?.user?.role !== "admin") {
			throw redirect({ to: "/" });
		}
	},
	component: CustomerMappingSettingsRoute,
});

function CustomerMappingSettingsRoute() {
	return (
		<RouteShell>
			<CustomerMappingSettingsPage />
		</RouteShell>
	);
}

function CustomerMappingSettingsPage() {
	// throwOnError: same shape as invoicing.tsx — qbo.status load failures
	// must not silently degrade to the "Not connected" CTA. The shell
	// handles the failure; the CTA only appears for confirmed
	// `connected: false`.
	const { data: qboStatus, isLoading } = trpc.qbo.status.useQuery(undefined, {
		throwOnError: true,
	});

	return (
		<SettingsLayout>
			<div>
				<h2 className="text-lg font-semibold text-[#1e1e20]">Customer Mapping</h2>
				<p className="mt-1 text-sm text-[#6b7280]">
					Link PayrollMart customers to QuickBooks customer records.
				</p>
			</div>
			{isLoading ? (
				<div className="h-40 w-full animate-pulse rounded-lg bg-[#f3f4f6]" />
			) : qboStatus?.connected ? (
				<CustomerMappingTab />
			) : (
				<QuickBooksNotConnected />
			)}
		</SettingsLayout>
	);
}

function QuickBooksNotConnected() {
	return (
		<div className="flex flex-col items-center rounded-lg border border-dashed border-[#e5e7eb] bg-white py-10">
			<CloudOff className="h-8 w-8 text-[#e5e7eb]" strokeWidth={1} />
			<p className="mt-3 text-sm font-medium text-[#1e1e20]">QuickBooks not connected</p>
			<p className="mt-1 max-w-sm text-center text-xs text-[#9ca3af]">
				Connect your QuickBooks Online account before mapping customers.
			</p>
			<Link
				to="/settings/quickbooks"
				className="mt-4 rounded bg-[#4f46e5] px-4 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-[#4338ca]"
			>
				Go to QuickBooks settings
			</Link>
		</div>
	);
}
